<template>
    <div class="container">
        <div class="row">
            <div class="col-5 col-md-7 col-lg-9 px-0">
                <div class="d-flex justify-content-start h-100 flex-wrap pl-3 ml-3">
                    <template v-if="entryCounter !== null">
                        <h2 class="align-self-start"> {{ entryCounter }} {{$t('cat.header.vehicles')}} </h2>
                        <span class="display-2 d-block pl-2"> {{ $t('cat.header.available')}} </span>
                    </template>
                    <b-skeleton class="align-self-center" width="170px" v-else></b-skeleton>
                </div>
            </div>
            <div class="col-7 col-md-5 col-lg-3">
                <sort-select></sort-select>
            </div>
        </div>
    </div>
</template>

<script>
import SortSelect from "../atoms/SortSelect.vue";
import { EventBus } from "../../event-bus"
import { BSkeleton } from "bootstrap-vue";
export default {
    name: 'CatalogFilterHeader',
    components: {
        SortSelect,
        BSkeleton
    },
    data(){
        return {
            entryCounter: null
        }
    },
    mounted() {
        EventBus.$on('change-entry-counter', this.getEntryCounter);
    },
    methods: {
        getEntryCounter(data) {
            this.entryCounter = data
        },
    }
}
</script>
